import axios from 'axios';
import { APP_ROUTES } from '@/constants/routes';
import { STORAGE_KEYS } from '@/constants/storage';

const API_BASE_URL = import.meta.env.VITE_API_URL ?? 'http://localhost:8787';
const AUTH_ENDPOINTS = {
  login: '/api/admin/login',
  verifyToken: '/api/admin/verify-token',
} as const;

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

const NO_AUTH_ENDPOINTS = [AUTH_ENDPOINTS.login, AUTH_ENDPOINTS.verifyToken];

api.interceptors.request.use((config) => {
  const isNoAuthEndpoint = NO_AUTH_ENDPOINTS.some((endpoint) =>
    config.url?.endsWith(endpoint) || config.url?.startsWith(endpoint)
  );

  if (!isNoAuthEndpoint) {
    const token = localStorage.getItem(STORAGE_KEYS.adminToken);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const isLoginRequest = error.config?.url?.endsWith(AUTH_ENDPOINTS.login);
    const isVerifyTokenRequest = error.config?.url?.endsWith(AUTH_ENDPOINTS.verifyToken);

    if (error.response?.status === 401 && !isLoginRequest && !isVerifyTokenRequest) {
      localStorage.removeItem(STORAGE_KEYS.adminToken);

      try {
        const { useAuthStore } = await import('../../store/authStore');
        useAuthStore.getState().logout();
      } catch {
        // Keep auth cleanup resilient even if store import fails.
      }

      if (window.location.pathname !== APP_ROUTES.login) {
        window.location.href = APP_ROUTES.login;
      }
    }

    return Promise.reject(error);
  }
);

export default api;
